import React from 'react';

import styles from './SiteRequirements.module.postcss';

function SiteRequirements() {
  return (
    <div className='GrayBg'>
      <section className={'Section--extraPadding ' + styles.SiteRequirements}>
        <div>
          <img src='/static/images/truck_illo.png' alt='Site Requirements' loading='lazy' />
        </div>
        <div>
          <h3>Simple Site Requirements</h3>

          <div className={styles.SiteRequirements_grid}>
            <div><strong>Power:</strong></div>
            <div>Not needed!</div>

            <div><strong>Space:</strong></div>
            <div>Minimum 30ft x 8ft area for setup</div>

            <div><strong>Water:</strong></div>
            <div>Not required!</div>

            <div><strong>Parking:</strong></div>
            <div>Flat surface required!</div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default SiteRequirements;
